
const KeyOfferingCard = ({ 
    title = "PCSS", 
    description = "The Public Cloud Shared Services (PCSS) team is dedicated to delivering innovative, secure, and scalable cloud solutions.", 
    icon = <span>📌</span> 
}) => {
    return (
        <div className="card p-3">
            <div className="text-center mb-3">
                {icon}
            </div>
            <h3 className="card-title h5 text-center">
                {title}
            </h3>
            <p className="card-text text-center">
                {description}
            </p>
        </div>
    );
};

export default KeyOfferingCard;
